import type { SalesChecklist } from "@expert/contentful";
import { getLogger } from "@expert/logging";
import { Text } from "@mantine/core";
import type { JSX } from "react";
import React from "react";
import { usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useSessionId } from "@/sdk/sessions/hooks/useSessionId";
import type { EligibleProduct } from "../../stores";
import { useProductOfferStore } from "../../stores";
import { SaleProgress } from "../../types";
import { FullOfferChecklist } from "../FullOfferChecklist/FullOfferChecklist";
import { SalesFooter } from "./SalesFooter";

const logger = getLogger({
    module: "full-offer-checklist",
    supportTeam: "sales",
});

export function FullOfferChecklistStep({
    product,
    salesChecklist,
}: {
    product: EligibleProduct;
    salesChecklist?: SalesChecklist;
}): JSX.Element | null {
    const sessionId = useSessionId();
    const { isUnifiedSalesViewEnabled } = usePartnerFeatureConfigured();

    if (!salesChecklist) {
        logger.error({ product, salesChecklist }, "Full offer checklist failed to render");
    }
    return (
        <>
            {product.saleProgress === SaleProgress.InProgress && salesChecklist ? (
                <FullOfferChecklist salesChecklist={salesChecklist} />
            ) : (
                <Text mt="20%" c="dark.1" size="sm">
                    Offer checklist is currently unavailable. Try again later
                </Text>
            )}
            <SalesFooter
                onBack={
                    isUnifiedSalesViewEnabled
                        ? () => {
                              useProductOfferStore.getState().updateSelectedProduct(sessionId, undefined);
                          }
                        : undefined
                }
                product={product}
            />
        </>
    );
}
